import { useMemo } from 'react'

import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { Table as TableV2 } from '@baseV2'
import { strings } from '@constants'
import { formatMixedQuantities } from '@utils'

const SpoOrderDetails = ({ data }) => {
	const orderDetails = data?.order_details ?? []
	const columns = useMemo(() => {
		return [
			{ label: strings('order_id'), key: 'order_id', mobile: true, sortable: false, align: 'left' },
			{ label: strings('input', 'type'), key: 'input_type', mobile: true, sortable: false, align: 'center' },
			// shown in the order's own unit (weight kg → MT, pieces → PCS, …)
			{ label: 'Allotted Quantity', key: (row) => formatMixedQuantities([row], 'allotted_weight'), mobile: true, sortable: false, align: 'right' },
		]
	}, [])

	return (
		<>
			<DrawerBodyWrapper>
				<TableV2
					data={orderDetails}
					columns={columns}
					rowClickable={false}
					hideFooter
				/>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper></DrawerFooterWrapper>
		</>
	)
}

export default SpoOrderDetails
